<template>
  <div class="list-control d-flex">
    <div v-if="isTablet || isMobile" class="col-auto list-control__mobile d-flex flex-column justify-content-center">
      <div class="d-flex justify-content-end align-items-center">
        <slot name="before-filter-icon" />
        <span
          v-click-outside="close"
          class="cursor-pointer filter-icon"
          @click="open = !open"
        >
          <font-awesome-icon icon="cog" size="lg" />
        </span>
      </div>

      <transition-expand-side v-if="open" :expand-direction="'expand-side-left'">
        <div class="list-control__mobile__pane d-flex flex-column">
          <span class="close-pane ml-4 mb-md-4 cursor-pointer" @click="open = !open">
            <font-awesome-icon :icon="['far', 'times-circle']" size="2x" />
          </span>
          <div class="list-control__mobile__pane__scrollable d-flex flex-column">
            <div class="d-flex flex-column">
              <slot name="contextual" />
            </div>
          </div>
        </div>
      </transition-expand-side>
    </div>
    <div v-else class="d-flex list-control__desktop">
      <div class="d-flex justify-content-end filter">
        <slot name="contextual" />
      </div>
    </div>
  </div>
</template>

<script>
import TransitionExpandSide from "@/components/animation/TransitionExpandSide";
import userDevice from "@/imports/mixins/userDevice";

export default {
  name: "CoverageControl",
  components: {TransitionExpandSide},
  mixins: [userDevice],
  data: function () {
    return {
      open: false,
    }
  },
  methods: {
    close: function () {
      this.open = false;
    },
  },
  created: function() {
    this.$eb.$on('nav-state', (state) => {
      if (state === true) {
        this.open = false;
      }
    });
  },
  destroyed() {
    this.$eb.$off('nav-state');
  },
}
</script>

<style scoped lang="scss">
.close-pane {
@include media-breakpoint-down(sm) {
  margin-bottom: 40px;
}
}
</style>
